import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { List, ListItem, ListItemIcon, ListItemText, Collapse } from '@material-ui/core';
import { Link } from 'react-router-dom';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import SupervisorAccount from '@material-ui/icons/SupervisorAccount';
import SettingsIcon from '@material-ui/icons/Settings';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import DashboardIcon from '@material-ui/icons/Dashboard';

const useStyles = makeStyles((theme) => ({
  listItem: {
    paddingLeft: theme.spacing(1),
  },
  nested: {
    paddingLeft: theme.spacing(1),
  },
  deeplyNested: {
    paddingLeft: theme.spacing(1),
  },
}));

const Sidebar = () => {
  const classes = useStyles();
  const [openAdmin, setOpenAdmin] = useState(false);
  const [openVeiculos, setOpenVeiculos] = useState(false);
  const [openProcedimentos, setOpenProcedimentos] = useState(false);
  const [openAbastecimentos, setOpenAbastecimentos] = useState(false);




  const handleAdminClick = () => {
    setOpenAdmin(!openAdmin);
  };

  const handleVeiculosClick = () => {
    setOpenVeiculos(!openVeiculos);
  };

  const handleProcedimentosClick = () => {
    setOpenProcedimentos(!openProcedimentos);
  };

  const handleAbastecimentosClick = () => {
    setOpenAbastecimentos(!openAbastecimentos);
  };

  return (
    <List>
      {/* Menu Dashboard */}
      <ListItem button component={Link} to="/frotas/dashboard" className={classes.listItem}>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItem>

      {/* Menu Cadastro */}
      <ListItem button onClick={handleAdminClick} className={classes.listItem}>
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary="Cadastro" />
        {openAdmin ? <ExpandLess /> : <ExpandMore />}
      </ListItem>

      <Collapse in={openAdmin} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {/* Submenu Veículos */}
          <ListItem button onClick={handleVeiculosClick} className={classes.nested}>
            <ListItemIcon>
              <SupervisorAccount />
            </ListItemIcon>
            <ListItemText primary="Veículos" />
            {openVeiculos ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={openVeiculos} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button component={Link} to="/frotas/veiculo" className={classes.deeplyNested}>
                <ListItemIcon>
                  <CreateNewFolderIcon />
                </ListItemIcon>
                <ListItemText primary="Veículo" />
              </ListItem>
              <ListItem button component={Link} to="/frotas/marcaveiculo" className={classes.deeplyNested}>
                <ListItemIcon>
                  <CreateNewFolderIcon />
                </ListItemIcon>
                <ListItemText primary="Marcas" />
              </ListItem>
              <ListItem button component={Link} to="/frotas/modeloveiculo" className={classes.deeplyNested}>
                <ListItemIcon>
                  <CreateNewFolderIcon />
                </ListItemIcon>
                <ListItemText primary="Modelos" />
              </ListItem>
              <ListItem button component={Link} to="/frotas/tipoveiculo" className={classes.deeplyNested}>
                <ListItemIcon>
                  <CreateNewFolderIcon />
                </ListItemIcon>
                <ListItemText primary="Tipos" />
              </ListItem>
            </List>
          </Collapse>
        </List>
      </Collapse>

      {/* Menu Procedimentos */}
      <ListItem button onClick={handleProcedimentosClick} className={classes.listItem}>
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary="Procedimentos" />
        {openProcedimentos ? <ExpandLess /> : <ExpandMore />}
      </ListItem>

      <Collapse in={openProcedimentos} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {/* Submenu Abastecimentos */}
          <ListItem button onClick={handleAbastecimentosClick} className={classes.nested}>
            <ListItemIcon>
              <SupervisorAccount />
            </ListItemIcon>
            <ListItemText primary="Abastecimentos" />
            {openAbastecimentos ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={openAbastecimentos} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button component={Link} to="/frotas/abastecimento" className={classes.deeplyNested}>
                <ListItemIcon>
                  <CreateNewFolderIcon />
                </ListItemIcon>
                <ListItemText primary="Lançar" />
              </ListItem>
            </List>
          </Collapse>
        </List>
      </Collapse>

      {/* Menu Sair */}
      <ListItem button component={Link} to="/logout" className={classes.listItem}>
        <ListItemIcon>
          <LockOpenIcon />
        </ListItemIcon>
        <ListItemText primary="Sair" />
      </ListItem>
    </List>
  );
};

export default Sidebar;
